import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FUMCarrier } from '../../../models/FUMCarrier';
import { ToastrService } from 'ngx-toastr';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FUMEnterpriseService } from '../../../services/fum-enterprise.service';
import { Enterprise } from '../../../../shared/enterprise-multiselect/Enterprise';
import { FUMEnterprise } from '../../../models/FUMEnterprise';

@Component({
  selector: 'fum-enterprise-component',
  templateUrl: './fum-enterprise.component.html'
})
export class FUMEnterpriseComponent implements OnInit {
  @Input()
  fumCarrierFile: FUMCarrier;

  @Output() close: EventEmitter<any> = new EventEmitter<any>();

  selectedEnterprises: FUMEnterprise[] = [];
  associationForm: FormGroup;
  showCustomerAutocomplete: boolean = false;

  constructor(
    private fumEnterpriseService: FUMEnterpriseService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    this.resetForm();
  }

  public resetForm(): void {
    this.showCustomerAutocomplete = true;

    this.selectedEnterprises = this.fumCarrierFile
      ? this.fumCarrierFile.enterprises
      : [];

    this.associationForm = new FormGroup({
      selectedEnterprises: new FormControl(this.selectedEnterprises, [
        Validators.required,
        Validators.minLength(1)
      ])
    });
  }

  selectEnterprise($event: Enterprise[]) {
    this.associationForm.controls.selectedEnterprises.setValue($event);
  }

  submit(): void {
    this.fumEnterpriseService
      .syncAssociations(
        this.fumCarrierFile.carrierID,
        this.associationForm.controls.selectedEnterprises.value
      )
      .subscribe(
        () => {
          this.toastr.success(
            'FUM Carrier/Customer Association Created Successfully!',
            'Success'
          );
          this.cancel();
        },
        (err) => {
          this.toastr.error(
            `<div class="mt-2" style="width: 100%;">Error: "${
              err.error
                ? !err.error.error
                  ? err.error
                  : err.error.error
                : err.message
            }"<div>`,
            'FUM Carrier/Customer Association Could Not Be Created!'
          );
          this.cancel();
        }
      );
  }

  cancel(): void {
    this.close.emit();
    this.showCustomerAutocomplete = false;
  }
}
